import RegisterSuccess from './account/RegisterSuccess';
import { connect } from 'react-redux';
import {
  registrationStatusDataSelector,
  isProfileIncompleteUserSelector,
  isRegisterIncompleteUserSelector,
  keycloakVerifyStatusSelector,
  preBookingStatusSelector
} from '../helpers/selectors';
import { navigateToBookings, navigateToHomePage } from '../utils/utils';
import { useCallback, useEffect, useRef } from 'react';
import { clearRegistrationStatusData } from '../actions/user';
import { isLoginVerificationFailed } from '../helpers/ssoRegistrationFlow';

export function RegistrationStatus(p) {
  // The warning ends registration as soon as it appears, so everything it renders
  // must come from the first render rather than from the store the effect clears.
  // A missing snapshot means there is no registration result to show at this URL.
  const status = useRef(
    p.registrationStatusData
      ? {
          registrationStatusData: p.registrationStatusData,
          isRegisterIncompleteUser: p.isRegisterIncompleteUser,
          isProfileIncompleteUser: p.isProfileIncompleteUser,
          preBookingStatus: p.preBookingStatus,
          loginVerificationFailed: isLoginVerificationFailed(p.keycloakVerifyStatus),
          clearRegistrationState: p.clearRegistrationStatusData
        }
      : null
  ).current;

  useEffect(() => {
    if (!status) {
      navigateToHomePage();
      return;
    }

    if (status.loginVerificationFailed) status.clearRegistrationState();
  }, [status]);

  const handleSubmit = useCallback(() => {
    if (!status) return;

    if (status.loginVerificationFailed) {
      navigateToHomePage();
    } else if (status.preBookingStatus) {
      navigateToBookings();
    } else {
      navigateToHomePage();
    }
  }, [status]);

  if (!status) return null;

  const d = status.registrationStatusData;

  return (
    <div className="creation-page register-page profile-page">
      <div className="scope-content active">
        <RegisterSuccess
          isCreationPage
          email={d.email}
          firstName={d.firstName}
          onSubmit={handleSubmit}
          isRegisterIncompleteUser={status.isRegisterIncompleteUser}
          isProfileIncompleteUser={status.isProfileIncompleteUser}
          loginVerificationFailed={status.loginVerificationFailed}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isRegisterIncompleteUser: isRegisterIncompleteUserSelector(state),
    isProfileIncompleteUser: isProfileIncompleteUserSelector(state),
    preBookingStatus: preBookingStatusSelector(state),
    registrationStatusData: registrationStatusDataSelector(state),
    keycloakVerifyStatus: keycloakVerifyStatusSelector(state)
  };
};

const mapDispatchToProps = {
  clearRegistrationStatusData
};

const ConnectedRegistrationStatus = connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationStatus);

export default ConnectedRegistrationStatus;
